import React from 'react';
import AddNew from './modalSearchFilterAddNew';
import { useTranslation } from 'react-i18next';
import styles from './modalSearchFilter.module.css';

const ModalSearchFilter = (props) => {

    const { id, placeholder, items, search, invertGoals, icon_loading, 
        handleGreenGoals, includeGreenGoals, showGreenCheckbox, 
        handleArchivedKpis, includeArchivedKpis,
        errormsg, closedKr, addNew, addNewItem, handleFocusLock, ariaLabel } = props;
    
    const type = id;
    const keyResult = !!((type == 'key_result' || type == 'objective'));
    const lastMeetingActions = (type == 'last_meeting_actions');
    const isKpi = (type == 'kpi');
    const { t } = useTranslation();
    
    return (
        <>
            {id !== 'onenote' ? (
            <>
                <div className={`addwoboitem-text-wrapper ${(keyResult || isKpi || addNew) ? "kr-style-searchbox" : lastMeetingActions ? "displayNone" : ""}`}>
                    <i className="icon icon-outline-search-18px"></i>
                    <input
                        id="searchInputBox"
                        className={((type == "workstream" || type == "ai") && !addNew) ? "workstream-input": ""}
                        name="s"
                        type="text"
                        data-testid="searchbox"
                        autoComplete="off"
                        placeholder={placeholder}
                        onChange={search}
                        aria-label={ariaLabel ? ariaLabel : ''}
                    />
                </div>
                {addNew &&
                    <AddNew type={id} addNewItem={addNewItem} handleFocusLock={handleFocusLock}/>
                }
            </>
            ) : ''}
            {isKpi && (
                <div className="chkbox wbcheckboxcomp displayInLineBlock">
                    <span className={styles.checkboxIcon}>
                        <div className={includeArchivedKpis ? "icon icon-outline-check_box-18px" : "icon icon-outline-check_box_outline_blank-18px"} checked={includeArchivedKpis} name="archivedkpi" id="archivedKpiCheckM" data-testid="archivedKpiCheckM" onClick={e => handleArchivedKpis(e)}/>
                    </span>
                    <span className={styles.checkboxLabel}>{t('Include archived KPIs')}</span>
                </div>
            )}
            {
            keyResult
                && (
                <div className="chkbox wbcheckboxcomp displayInLineBlock">
                    {/* <input type="checkbox" className="css-checkbox" name="closegoalkr" id="closeGoalCheckM" onChange={e => invertGoals(e, items)} /> */}
                    <span style={{cursor:'pointer', verticalAlign: "bottom"}}>
                        <div className={closedKr ? "icon icon-outline-check_box-18px" : "icon icon-outline-check_box_outline_blank-18px"} checked={!closedKr} name="closegoalkr" id="closeGoalCheckM" data-testid="closeGoalCheckM" onClick={e => invertGoals(e, items)}/>
                    </span>
                    <label className="css-label modalParaText" htmlFor="closeGoalCheckM" />
                    <span style={{ fontSize: '14px',marginLeft: '10px',color: 'rgba(0, 0, 0, 0.84)' }}>{t('Include closed')} {t('OKRs')}</span>
                </div>
                )
            }
            {/* {(showGreenCheckbox && !!items.length) && */}
            {(showGreenCheckbox) &&
                <div className="showRiskAllSelDiv">
                    <span  className="greenStatusLabel italicLabel">{!includeGreenGoals ? t('Showing at-risk items') : t('Showing all items')}</span>
                    {/* <input type="checkbox" className="css-checkbox" name="greengoalkr" id="greenStatusCheckM" onChange={e => handleGreenGoals(e)} /> */}
                    <span style={{cursor:'pointer', verticalAlign: "bottom"}}>
                        <div className={includeGreenGoals ? "icon icon-outline-check_box-18px" : "icon icon-outline-check_box_outline_blank-18px"} checked={!includeGreenGoals}name="greengoalkr" id="greenStatusCheckM" onClick={e => handleGreenGoals(e)}/>
                    </span>
                    <label className="css-label modalParaText" htmlFor="greenStatusCheckM" />
                    <span className= "greenCheckBoxLabel ">{type == 'key_result'? `${t('Include green status')} ${t('key results')}`: `${t('Include green status')} ${t('OKRs')}`}</span>
                </div>
            }
            {errormsg && 
                    <div className="errormsg" role="alert"
                        style={{ 
                            display: errormsg ? "block" : "none", 
                            color: "#D93630",
                            fontSize: "12px",
                            padding: "5px 0px",
                            whiteSpace: "pre-line"
                            }}>
                        {t('Please select at least one item.')}
                    </div>
                }
        </>
    )
};

export default ModalSearchFilter;